<template>
  <footer class="footer px-4">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-4">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} <a href="https://www.iripple.com" class="font-weight-bold ml-1" target="_blank">iRipple, Inc.</a> {{version}}
        </div>
      </div>
      <!-- <div class="col-lg-4">
        <div class="copyright text-center text-lg-center text-muted">
            <a class="float-center" href="https://hostedscan.com"><img src="https://hostedscan.com/protected-by-hostedscan.svg" alt="HostedScan | An automated vulnerability scanner" height="68px" width="162px"/></a>
        </div>
      </div> -->
      <!-- <div class="col-lg-4">
        <div class="copyright text-center text-lg-center text-muted">
          <a href="https://hostedscan.com"><img src="https://hostedscan.com/protected-by-hostedscan-dark.svg" alt="HostedScan | An automated vulnerability scanner" height="68px" width="162px"/></a>
        </div>
      </div> -->
      <div class="col-lg-4">
        <div class="copyright text-center text-lg-right text-muted">
          <a href="https://stats.uptimerobot.com/j0OB0gn7Pg" class="font-weight-bold ml-1" target="_blank">Status Page</a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapState } from 'vuex'
import HTTPRequest from '../controllers/httpRequest.js';

export default {
  data() {
    return {
      year: new Date().getFullYear(),
      version: ''
    };
  },
  mounted: async function() {
    // const request = await HTTPRequest.getRequest(`${this.endPoint}settings/latest_web_version`);
    // this.version = request.version ? `v${request.version}` : '';
  },
  computed: {
    ...mapState(['endPoint']),
  },
};
</script>
<style></style>
